import { useConfigContext } from '@fe-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEY } from './data/useSelfregSessionDetails';
import { create, TAccountCreatePayload } from '@api/queries/account';

export const useCreateAccount = ({ sessionId }: { sessionId: string }) => {
  const { config } = useConfigContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: TAccountCreatePayload) =>
      create({
        baseUrl: config.apiUrls.ccapi as string,
        sessionId,
        payload,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY],
      });
    },
  });
};
